import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import React from 'react';
const DelimiterList = ({ children, className, delimiter = '·', ...divProps }) => {
    const childItems = React.Children.toArray(children);
    const newChildren = childItems.map((child, idx) => {
        if (React.isValidElement(child) && child.type === DelimiterItem) {
            // @ts-expect-error props are of unknown type since React 19 this needs refactoring
            const key = child.props.id;
            return (_jsxs(React.Fragment, { children: [child, idx !== childItems.length - 1 && (_jsxs(TextPrimitive, { className: "inline-flex !text-inherit", children: [" ", delimiter, " "] }))] }, key));
        }
        return null;
    });
    return (_jsx("div", { className: `gap-2 flex items-center ${className}`, ...divProps, children: newChildren }));
};
const DelimiterItem = ({ children }) => {
    return _jsx(_Fragment, { children: children });
};
export const Root = DelimiterList;
export const Item = DelimiterItem;
//# sourceMappingURL=DelimiterList.js.map